import { Link, useLocation } from "react-router-dom";
import { Wordmark } from "./shared";

/**
 * Shared site header. Used on every page (home, /science, /claims, /privacy, /terms)
 * so the logo size/position and nav are identical everywhere.
 * On the homepage, section links are plain in-page anchors (Lenis smooth-scrolls them).
 * On any other page, the same links route home first, then land on that hash.
 */
export const Nav = ({ onCta }) => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <header
      className="nav-fixed border-b border-[#F2F0EB]/10 bg-[#0B0B0C]"
      data-testid="main-nav"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16 gap-3">
          {isHome ? (
            <a href="#top" className="flex items-center shrink-0" data-testid="nav-logo">
              <Wordmark className="h-3 sm:h-[14px]" />
            </a>
          ) : (
            <Link to="/" className="flex items-center shrink-0" data-testid="nav-logo">
              <Wordmark className="h-3 sm:h-[14px]" />
            </Link>
          )}
          <nav className="hidden md:flex items-center gap-8 font-mono-brand text-[11px] tracking-[0.15em] uppercase text-[#9DA1A8]">
            {isHome ? (
              <a href="#instrument" className="hover:text-[#F2F0EB] transition-colors" data-testid="nav-link-system">What's inside</a>
            ) : (
              <Link to="/#instrument" className="hover:text-[#F2F0EB] transition-colors" data-testid="nav-link-system">What's inside</Link>
            )}
            {isHome ? (
              <a href="#how" className="hover:text-[#F2F0EB] transition-colors" data-testid="nav-link-how">How it works</a>
            ) : (
              <Link to="/#how" className="hover:text-[#F2F0EB] transition-colors" data-testid="nav-link-how">How it works</Link>
            )}
            <Link to="/science" className="hover:text-[#F2F0EB] transition-colors" data-testid="nav-link-science">The science</Link>
            {isHome ? (
              <a href="#faq" className="hover:text-[#F2F0EB] transition-colors" data-testid="nav-link-faq">FAQ</a>
            ) : (
              <Link to="/#faq" className="hover:text-[#F2F0EB] transition-colors" data-testid="nav-link-faq">FAQ</Link>
            )}
          </nav>
          {isHome ? (
            <button
              onClick={onCta}
              className="cta-primary px-4 sm:px-5 py-2 sm:py-2.5 text-[11px] sm:text-xs whitespace-nowrap shrink-0"
              data-testid="nav-cta-button"
            >
              <span className="sm:hidden">Get my code</span>
              <span className="hidden sm:inline">Create my Source Code</span>
            </button>
          ) : (
            <Link
              to="/#secure"
              className="cta-primary px-4 sm:px-5 py-2 sm:py-2.5 text-[11px] sm:text-xs whitespace-nowrap shrink-0 inline-flex items-center justify-center"
              data-testid="nav-cta-button"
            >
              <span className="sm:hidden">Get my code</span>
              <span className="hidden sm:inline">Create my Source Code</span>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
